import React, { useState, useEffect } from "react";

import { API_URL, isFieldError } from "./helpers";

import Hdg from "./components/Hdg";
import Alert from "./components/Alert";
import Select from "./components/Select";
import InputUncontrolled from "./components/InputUncontrolled";
import Input from "./components/Input";
import Msg from "./components/Msg";
import Submit from "./components/Submit";

const Csv = () => {
	const [dates, setDates] = useState([]);
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	useEffect(() => {
		init();
	}, []);

	const init = async (id) => {
		const url = new URL(`${API_URL}/csvInit`);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setDates(json.dates);
				setAlert({});
			} else {
				setAlert({ type: "error", text: json.text });
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleUpdate = (name, value) => {
		if (name === "date") {
			const found = dates.find((element) => element.id === value);
			const array = found.val.split("-");

			setNames((names) => ({
				...names,
				[name]: value ? value : "",
				start: array[0],
				end: array[1],
			}));
		} else {
			setNames((names) => ({ ...names, [name]: value ? value : "" }));
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/csv`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setMsg({
					type: "success",
					text: json.text,
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<div id="full-column">
			<Hdg />

			<p>
				Use this form to email yourself a .csv file of Share Your Story
				submissions.
			</p>

			{alert.type ? (
				<Alert data={alert} />
			) : (
				<form
					method="post"
					action="/"
					onSubmit={(e) => handleSubmit(e)}
					className="well"
				>
					<h3 style={{ marginTop: "0" }}>Share Your Story CSV Export Form</h3>

					<div className="form-group">
						<Select
							name="date"
							label="Date Range"
							reqd={true}
							value={""}
							options={dates}
							update={handleUpdate}
							error={isFieldError(errors, "date")}
						/>
						<div className="empty" />
					</div>

					<div className="form-group">
						<InputUncontrolled
							name="start"
							label="Start Date"
							reqd={true}
							value={names.start || ""}
							update={handleUpdate}
							errors={errors}
						/>
						<InputUncontrolled
							name="end"
							label="End Date"
							reqd={true}
							value={names.end || ""}
							update={handleUpdate}
							errors={errors}
						/>
					</div>

					<div className="form-group">
						<Input
							name="email"
							label="Email Address"
							reqd={true}
							value={""}
							update={handleUpdate}
							errors={errors}
						/>

						<div className="empty" />
					</div>

					<div className="msg-submit">
						{msg.type && <Msg data={msg} />}

						<div
							className={
								msg.type === "working" || msg.type === "success"
									? "hidden"
									: "submit-container"
							}
						>
							<Submit path="" left="" submit="Generate & Email CSV" />
						</div>
					</div>
				</form>
			)}
		</div>
	);
};

export default Csv;
